import moment from 'moment';
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import Tooltip from "../../shared/components/Tooltip";
import { InboxArrowDownIcon } from "@heroicons/react/20/solid";
import { Desktop, Mobile } from '../../shared/components/Responsive';
import { generate } from '../../../routing/routes'

export default function InvoiceItemsList({ invoices, editable = false, isLoading= false, endUser = false}) {
    const { t } = useTranslation();
    const formattedDate = (invoice) => new Date(invoice.createdAt);

    return (<>
        <Mobile>
            {invoices.map((invoice) =>
                <div key={invoice.id} className="flex justify-between items-center min-h-[75px] my-4 text-xs bg-stone-100 text-gray-600 border border-stone-300 rounded-md overflow-hidden">
                    <div className="flex flex-col items-center text-center py-2 px-3">
                        <div>{invoice.numbering}</div>
                        <hr className="my-1 border-1 border-solid border-stone-300 w-1/2"/>
                        <div>
                            <span>{moment(formattedDate(invoice)).format("DD MMMM YYYY")}</span>
                        </div>
                    </div>
                    <div className="px-2 text-base">{invoice.balance.amount.toFixed(2)}€</div>
                    <button 
                        className="self-stretch px-4 text-sm shadow-inner bg-orange-500 hover:bg-orange-600 text-white"
                    >
                        <InboxArrowDownIcon className="h-6 w-6" />
                    </button>
                </div>
            )}
        </Mobile>
        <Desktop>
            <table className="table-auto w-full rounded-lg overflow-hidden">
                <thead className="bg-gray-300 text-gray-600 h-[48px] text-lg">
                    <tr>
                        <th className="px-2">{t('account.date')}</th>
                        <th className="px-2">{t('account.reference')}</th>
                        <th className="px-2 text-end">{t('account.amount')}</th>
                        <th className="px-2">{t('account.download')}</th>
                    </tr>
                </thead>
                <tbody className="bg-stone-100">
                    {invoices.map((invoice) =>
                        <tr
                            key={invoice.id}
                            className={cx("group relative text-base text-gray-600", {
                                "opacity-50": isLoading
                        })}>
                            <td className={"bg-stone-200"}>
                                <div className="flex flex-col justify-center items-center text-base text-gray-600 ">
                                    <span className="text-xl">{moment(formattedDate(invoice)).format("DD")}</span>
                                    <span>{moment(formattedDate(invoice)).format("MMMM")}</span>
                                    <span>{moment(formattedDate(invoice)).format("YYYY")}</span>
                                </div>
                                <span className="absolute bottom-0 left-0 right-0 h-px bg-stone-300" />
                            </td>
                            <td className="p-1 text-center break-words break-all">
                                {invoice.numbering}
                            </td>
                            <td className="text-end p-2">
                                {invoice.balance.amount.toFixed(2)}€
                            </td>
                            <td>
                                <div className="flex px-2">
                                    <a href={generate('customer_reservation_invoice', { reference: invoice.numbering, invoiceId: invoice.id })} target='_blank' className="flex m-auto items-center justify-center">
                                        <Tooltip Icon={() => <InboxArrowDownIcon className="h-5 w-5" />} content={t('account_button.invoice_download')} className={"p-1.5 text-white bg-orange-500 hover:scale-110 active:bg-orange-800 cursor-pointer rounded-full"} />
                                    </a>
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Desktop>
    </>)
}
